import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserRule } from '@verify/shared-components/models';
import { AuthService } from '@verify/shared-components/services';
import { map, take } from 'rxjs';
import { GuideService } from '../services/guide/guide.service';

export const guideGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService: AuthService = inject(AuthService);
  const guideService: GuideService = inject(GuideService);
  const router: Router = inject(Router);

  const guideId = route.params['guideId'];
  if (guideId) {
    return guideService.getGuide(guideId).pipe(
      take(1),
      map((guide) => {
        if (!guide || guide.deleted) {
          return router.parseUrl('error?code=404');
        } else {
          const { rules, groupIds } = authService.currentUser;
          const isGuideAdmin = rules.includes(UserRule.guideAdmin);
          if (
            isGuideAdmin ||
            !guide.groupIds?.length ||
            guide.groupIds.some((gid) => groupIds.includes(gid))
          ) {
            return true;
          } else {
            return router.parseUrl('error?code=403');
          }
        }
      }),
    );
  }
  return router.parseUrl('error?code=404');
};
